module.exports = __webpack_public_path__ + "static/img/track-habits@3x.7293d5cc.png";